/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-08-12 11:24:53
 * @LastEditors: linxi
 * @LastEditTime: 2023-08-12 11:26:40
 */
export function getTypeName(type: string): string {
  switch (type) {
    case '1':
      return '常温'
    case '2':
      return '阴冷'
    case '3':
      return '冷藏'
    case '4':
      return '恒温'
  }
  return '-'
}
